import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=04c47dcc&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=04c47dcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c47dcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04c47dcc')) {
      api.createRecord('04c47dcc', component.options)
    } else {
      api.reload('04c47dcc', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=04c47dcc&scoped=true&", function () {
      api.rerender('04c47dcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25OhcF1KXrnRx/JS/comp/Voucher.vue"
export default component.exports